import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "note-header" }
const _hoisted_2 = { class: "note-title" }
const _hoisted_3 = {
  key: 0,
  class: "editing-tip"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "note-info-text" }, "笔记攻略", -1)
const _hoisted_5 = {
  key: 0,
  class: "note-editing"
}
const _hoisted_6 = { class: "note-photo-list" }
const _hoisted_7 = ["onClick", "src"]
const _hoisted_8 = { class: "note-footer" }
const _hoisted_9 = { class: "note-upload-time" }
const _hoisted_10 = { class: "data" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "time" }, "上传", -1)
const _hoisted_12 = { class: "re-upload-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!
  const _component_van_sticky = _resolveComponent("van-sticky")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["note-content pd", { pd: $props.progress == 2 }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 我的笔记"),
        ($props.progress == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "批改中"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "note-info",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openNoteStrategy && $setup.openNoteStrategy(...args)))
      }, [
        _createVNode(_component_van_icon, { name: "question-o" }),
        _hoisted_4
      ])
    ]),
    ($props.progress == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 老师正在对笔记进行批改，请耐心等待 "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notePicList, (item, index) => {
        return (_openBlock(), _createElementBlock("img", {
          onClick: ($event: any) => ($setup.handlePreview(index)),
          class: "photo-item",
          key: 'pic-' + index,
          src: item.resource_url
        }, null, 8, _hoisted_7))
      }), 128)),
      ($setup.notePicList.length % 3)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(3 - ($setup.notePicList.length % 3), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "photo-item",
              key: `${index}`
            }))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.commentInfo.updated_time), 1),
        _hoisted_11
      ]),
      ($props.progress != 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.showNoteSheet && $setup.showNoteSheet(...args)))
          }, [
            _createVNode(_component_van_icon, {
              name: "ellipsis",
              color: "#333",
              size: "0.43rem"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_action_sheet, {
      class: "note-action-sheet",
      show: $setup.isShowNoteSheet,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowNoteSheet) = $event)),
      onSelect: $setup.handleSelectEditAction,
      onCancel: $setup.handleEditActionCancel,
      actions: $setup.noteSheetActions,
      "cancel-text": "取消",
      "lock-scroll": "",
      "close-on-click-action": true
    }, null, 8, ["show", "onSelect", "onCancel", "actions"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.callUploadActionVisible,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.callUploadActionVisible) = $event)),
      onSelect: $setup.handleSelectUploadAction,
      onCancel: $setup.handleUploadActionCancel,
      actions: $setup.callUploadActions,
      "cancel-text": "取消",
      "lock-scroll": "",
      "close-on-click-action": true
    }, null, 8, ["show", "onSelect", "onCancel", "actions"]),
    _createVNode(_component_aio_confirm, {
      visible: $setup.confirmVisible,
      confirmInfo: $setup.confirmInfo
    }, null, 8, ["visible", "confirmInfo"]),
    ($props.progress == 2)
      ? (_openBlock(), _createBlock(_component_van_sticky, {
          key: 1,
          "offset-bottom": 58,
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "re-upload",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.callUploadAction({ type: 'reUpload' })))
              }, " 重新上传笔记 ")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}